import { motion } from "framer-motion";
import { Globe, Share2, Code2, Clapperboard } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";

const services = [
  {
    title: "Website Design & Development",
    description: "Custom, high-performance websites tailored to your brand's unique identity. We build responsive, accessible, and scalable digital experiences.",
    icon: Globe,
  },
  {
    title: "Social Media Management",
    description: "Strategic content creation and community engagement to grow your digital presence. We help you connect with your audience across all platforms.",
    icon: Share2,
  },
  {
    title: "Web Framework Support",
    description: "Expert assistance with modern web technologies. We ensure your technical stack is robust and future-proof.",
    icon: Code2,
  },
  {
    title: "Reel Editing & Production",
    description: "Captivating short-form video content designed for viral engagement. We edit, produce, and optimize reels for Instagram, TikTok, and YouTube Shorts.",
    icon: Clapperboard,
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">Our Expertise</h2>
          <p className="text-muted-foreground text-lg">
            Comprehensive digital solutions designed to propel your business forward.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full border-none shadow-lg hover:shadow-xl transition-shadow duration-300 group bg-card">
                <CardHeader>
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <service.icon className="w-6 h-6" />
                  </div>
                  <CardTitle className="text-xl font-bold">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
